export class CarouselControllerWillChangeSlideEvent extends Event {
  public static readonly KEY = "CarouselControllerWillChangeSlideEvent";

  constructor(public index: number, public scrollOffset: number) {
    super(CarouselControllerWillChangeSlideEvent.KEY);
  }
}
